import React from "react";
import { twMerge } from "tailwind-merge";

const TONE_CLASSES = {
  light: "bg-[var(--q-bg)] text-[var(--q-text)]",
  offwhite: "bg-[var(--q-bg-alt)] text-[var(--q-text)]",
  dark: "bg-[var(--q-bg-dark)] text-[var(--q-text-on-dark)]",
};

// Default vertical rhythm. Split into explicit pt/pb per breakpoint so that
// callers supplying responsive `pt-*` / `pb-*` overrides at md:/lg: correctly
// win via tailwind-merge conflict resolution. Callers must supply responsive
// overrides at every breakpoint they wish to change.
const DEFAULT_PADDING = "pt-16 pb-16 md:pt-24 md:pb-24 lg:pt-32 lg:pb-32";

export const Section = ({
  as: As = "section",
  tone = "light",
  className = "",
  children,
  ...rest
}) => {
  const toneClass = TONE_CLASSES[tone] || TONE_CLASSES.light;
  return (
    <As
      data-tone={tone}
      className={twMerge(toneClass, DEFAULT_PADDING, className)}
      {...rest}
    >
      {children}
    </As>
  );
};

export default Section;
